/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoachingRequest } from '../models/CoachingRequest';
import type { CoachInitialTaskResponse } from '../models/CoachInitialTaskResponse';
import type { CoachStatusResponse } from '../models/CoachStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiWorkstreamAssistService {

    /**
     * Start Assist Initial
     * Kick off Assist initial task. Poll GET .../assist/initial/generate/{task_id}.
     * @param requestBody
     * @returns CoachInitialTaskResponse Successful Response
     * @throws ApiError
     */
    public static startAssistInitialApiV1WorkstreamAssistInitialPost(
        requestBody: CoachingRequest,
    ): CancelablePromise<CoachInitialTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/assist/initial',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Assist Initial Status
     * @param taskId
     * @returns CoachStatusResponse Successful Response
     * @throws ApiError
     */
    public static getAssistInitialStatusApiV1WorkstreamAssistInitialGenerateTaskIdGet(
        taskId: string,
    ): CancelablePromise<CoachStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/assist/initial/generate/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Start Assist Iterate
     * @param requestBody
     * @returns CoachInitialTaskResponse Successful Response
     * @throws ApiError
     */
    public static startAssistIterateApiV1WorkstreamAssistIteratePost(
        requestBody: CoachingRequest,
    ): CancelablePromise<CoachInitialTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/assist/iterate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Assist Iterate Status
     * @param taskId
     * @returns CoachStatusResponse Successful Response
     * @throws ApiError
     */
    public static getAssistIterateStatusApiV1WorkstreamAssistIterateGenerateTaskIdGet(
        taskId: string,
    ): CancelablePromise<CoachStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/assist/iterate/generate/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
